import { useState, useCallback } from 'react';
import ReportsService from '@/services/reportsService';

export default function useGSTReport() {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGSTReport = useCallback(async ({ fromDate, toDate, viewBy }) => {
    try {
      setLoading(true);
      setError(null);
      setData([]);
      setSummary(null);

      const res = await ReportsService.getGSTReport({ fromDate, toDate, viewBy });
      const resData = res?.data ?? res;

      setSummary(resData?.summary ?? null);
      setData(resData?.table?.content ?? []);
    } catch (err) {
      console.error('GST report fetch error:', err);
      setError('Unable to fetch GST report data');
      setData([]);
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadGSTReport = useCallback(async ({ fromDate, toDate, viewBy, branchId }) => {
    try {
      setDownloadLoading(true);
      setError(null);

      const payload = { fromDate, toDate, viewBy };
      if (branchId) payload.branchId = branchId;

      const response = await ReportsService.getGSTReportDownload(payload);

      const blob = response.data;

      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'GSTR1.xlsx';

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('GST download error:', err);
      setError('Unable to generate GST report download');
    } finally {
      setDownloadLoading(false);
    }
  }, []);

  return {
    data,
    summary,
    loading,
    downloadLoading,
    error,
    fetchGSTReport,
    downloadGSTReport,
  };
}
